import { Glob } from "functions/Language";
import { OnlineDataGCRShort, OnlineDataPLA } from "functions/networking/NetTypes";


export const subscripted = {
	uln: <>U<sub>LN</sub></>,
	ull: <>U<sub>LL</sub></>,
};

export const fieldNames = Glob({
	en: {
		CosFi: "cos φ",
		CosFi_Mod: "cos φ",
		Current: "I",
		Frequency: "f",
		KFactor: "K factor",
		Over_Deviation_LL: "Over deviation U_LL",
		Over_Deviation_LN: "Over deviation U_LN",
		P: "P",
		Pf: "Pf",
		Pf_Mod: "Pf",
		Q: "Q",
		S: "S",
		Rotation: "Rotation",
		Tdd: "TDD",
		Thd_Current: "THD I",
		Thd_U_LL: "THD U_LL",
		Thd_U_LN: "THD U_LN",
		Temperature: "Temperature",
		U_LL: subscripted.ull,
		U_LN: subscripted.uln,
		Unbalance_I_I0: "Unbalance I0",
		Unbalance_I_I2: "Unbalance I2",
		Unbalance_LN_U0: "Unbalance U0",
		Unbalance_LN_U2: "Unbalance U2",
		Under_Deviation_LL: "Under deviation U_LL",
		Under_Deviation_LN: "Under deviation U_LN"
	},
	cs: {
		CosFi: "cos φ",
		CosFi_Mod: "cos φ",
		Current: "I",
		Frequency: "f",
		KFactor: "K faktor",
		Over_Deviation_LL: "Over deviation U_LL",
		Over_Deviation_LN: "Over deviation U_LN",
		P: "P",
		Pf: "Pf",
		Pf_Mod: "Pf",
		Q: "Q",
		S: "S",
		Rotation: "Rotace",
		Tdd: "TDD",
		Thd_Current: "THD I",
		Thd_U_LL: "THD U_LL",
		Thd_U_LN: "THD U_LN",
		Temperature: "Teplota",
		U_LL: subscripted.ull,
		U_LN: subscripted.uln,
		Unbalance_I_I0: "Unbalance I0",
		Unbalance_I_I2: "Unbalance I2",
		Unbalance_LN_U0: "Unbalance U0",
		Unbalance_LN_U2: "Unbalance U2",
		Under_Deviation_LL: "Under deviation U_LL",
		Under_Deviation_LN: "Under deviation U_LN"
	},
	pg: {
		CosFi: "cos φ",
		CosFi_Mod: "cos φ",
		Current: "I",
		Frequency: "f",
		KFactor: "Fator K",
		Over_Deviation_LL: "Over deviation U_LL",
		Over_Deviation_LN: "Over deviation U_LN",
		P: "P",
		Pf: "Pf",
		Pf_Mod: "Pf",
		Q: "Q",
		S: "S",
		Rotation: "Rotação",
		Tdd: "TDD",
		Thd_Current: "THD I",
		Thd_U_LL: "THD U_LL",
		Thd_U_LN: "THD U_LN",
		Temperature: "Temperatura",
		U_LL: subscripted.ull,
		U_LN: subscripted.uln,
		Unbalance_I_I0: "Unbalance I0",
		Unbalance_I_I2: "Unbalance I2",
		Unbalance_LN_U0: "Unbalance U0",
		Unbalance_LN_U2: "Unbalance U2",
		Under_Deviation_LL: "Under deviation U_LL",
		Under_Deviation_LN: "Under deviation U_LN"
	},
	es: {
		CosFi: "cos φ",
		CosFi_Mod: "cos φ",
		Current: "I",
		Frequency: "f",
		KFactor: "Factor K",
		Over_Deviation_LL: "Over deviation U_LL",
		Over_Deviation_LN: "Over deviation U_LN",
		P: "P",
		Pf: "Pf",
		Pf_Mod: "Pf",
		Q: "Q",
		S: "S",
		Rotation: "Rotación",
		Tdd: "TDD",
		Thd_Current: "THD I",
		Thd_U_LL: "THD U_LL",
		Thd_U_LN: "THD U_LN",
		Temperature: "Temperatura",
		U_LL: subscripted.ull,
		U_LN: subscripted.uln,
		Unbalance_I_I0: "Unbalance I0",
		Unbalance_I_I2: "Unbalance I2",
		Unbalance_LN_U0: "Unbalance U0",
		Unbalance_LN_U2: "Unbalance U2",
		Under_Deviation_LL: "Under deviation U_LL",
		Under_Deviation_LN: "Under deviation U_LN"
	},
} as const);

export const shortNames = Glob({
	en: {
		CosFi: "cos φ",
		CosFi_Mod: "cos φ",
		Current: "I",
		Frequency: "f",
		KFactor: "K factor",
		Over_Deviation_LL: "Over deviation",
		Over_Deviation_LN: "Over deviation",
		P: "P",
		Pf: "Pf",
		Pf_Mod: "Pf",
		Q: "Q",
		S: "S",
		Rotation: "Rotation",
		Tdd: "TDD",
		Thd_Current: "THD",
		Thd_U_LL: "THD",
		Thd_U_LN: "THD",
		Temperature: "Temperature",
		U_LL: subscripted.ull,
		U_LN: subscripted.uln,
		Unbalance_I_I0: "Unbalance I0",
		Unbalance_I_I2: "Unbalance I2",
		Unbalance_LN_U0: "Unbalance U0",
		Unbalance_LN_U2: "Unbalance U2",
		Under_Deviation_LL: "Under deviation",
		Under_Deviation_LN: "Under deviation"
	},

	cs: {
		CosFi: "cos φ",
		CosFi_Mod: "cos φ",
		Current: "I",
		Frequency: "f",
		KFactor: "K faktor",
		Over_Deviation_LL: "Over deviation",
		Over_Deviation_LN: "Over deviation",
		P: "P",
		Pf: "Pf",
		Pf_Mod: "Pf",
		Q: "Q",
		S: "S",
		Rotation: "Rotace",
		Tdd: "TDD",
		Thd_Current: "THD",
		Thd_U_LL: "THD",
		Thd_U_LN: "THD",
		Temperature: "Teplota",
		U_LL: subscripted.ull,
		U_LN: subscripted.uln,
		Unbalance_I_I0: "Unbalance I0",
		Unbalance_I_I2: "Unbalance I2",
		Unbalance_LN_U0: "Unbalance U0",
		Unbalance_LN_U2: "Unbalance U2",
		Under_Deviation_LL: "Under deviation",
		Under_Deviation_LN: "Under deviation"
	},
	pg: {
		CosFi: "cos φ",
		CosFi_Mod: "cos φ",
		Current: "I",
		Frequency: "f",
		KFactor: "Fator K",
		Over_Deviation_LL: "Over deviation",
		Over_Deviation_LN: "Over deviation",
		P: "P",
		Pf: "Pf",
		Pf_Mod: "Pf",
		Q: "Q",
		S: "S",
		Rotation: "Rotação",
		Tdd: "TDD",
		Thd_Current: "THD",
		Thd_U_LL: "THD",
		Thd_U_LN: "THD",
		Temperature: "Temperatura",
		U_LL: subscripted.ull,
		U_LN: subscripted.uln,
		Unbalance_I_I0: "Unbalance I0",
		Unbalance_I_I2: "Unbalance I2",
		Unbalance_LN_U0: "Unbalance U0",
		Unbalance_LN_U2: "Unbalance U2",
		Under_Deviation_LL: "Under deviation",
		Under_Deviation_LN: "Under deviation"
	},
	es: {
		CosFi: "cos φ",
		CosFi_Mod: "cos φ",
		Current: "I",
		Frequency: "f",
		KFactor: "Factor K",
		Over_Deviation_LL: "Over deviation",
		Over_Deviation_LN: "Over deviation",
		P: "P",
		Pf: "Pf",
		Pf_Mod: "Pf",
		Q: "Q",
		S: "S",
		Rotation: "Rotación",
		Tdd: "TDD",
		Thd_Current: "THD",
		Thd_U_LL: "THD",
		Thd_U_LN: "THD",
		Temperature: "Temperatura",
		U_LL: subscripted.ull,
		U_LN: subscripted.uln,
		Unbalance_I_I0: "Unbalance I0",
		Unbalance_I_I2: "Unbalance I2",
		Unbalance_LN_U0: "Unbalance U0",
		Unbalance_LN_U2: "Unbalance U2",
		Under_Deviation_LL: "Under deviation",
		Under_Deviation_LN: "Under deviation"
	},
} as const);

export const units = {
  CosFi: "",
  CosFi_Mod: "",
  Current: "A",
  Frequency: "Hz",
  KFactor: "",
  Over_Deviation_LL: "V",
  Over_Deviation_LN: "V",
  P: "W",
  Pf: "",
  Pf_Mod: "",
  Q: "VAr",
  S: "VA",
  Rotation: "",
  Tdd: "%",
  Thd_Current: "%",
  Thd_U_LL: "%",
  Thd_U_LN: "%",
  Temperature: "°C",
  U_LL: "V",
  U_LN: "V",
  Unbalance_I_I0: "%",
  Unbalance_I_I2: "%",
  Unbalance_LN_U0: "%",
  Unbalance_LN_U2: "%",
  Under_Deviation_LL: "V",
  Under_Deviation_LN: "V"
}

let assert1 : keyof typeof fieldNames.en extends ((keyof OnlineDataPLA) | (keyof OnlineDataGCRShort)) ? true : false = true;
let assert2 : keyof typeof units extends keyof typeof fieldNames.en ? true : false = true;
let assert3 : keyof typeof fieldNames.en extends keyof typeof units ? true : false = true;
